export default "__VITE_ASSET__CV9JJEi3__"